import { CampaignWithNodeDetails, NodeData } from './types';

export const _nodeCache: { data: NodeData[] | null; ts: number; ttl: number } = { data: null, ts: 0, ttl: 1000 * 60 * 5 }; // 5 minutes
export const _campaignCache = new Map<string, { data: CampaignWithNodeDetails[]; ts: number; ttl: number }>();

/**
 * Clear campaign cache for a specific user or all users
 * @param userId - Optional user ID. If not provided, clears all caches.
 */
export function clearCampaignCache(userId?: string): void {
  if (userId) {
    _campaignCache.delete(userId);
  } else {
    _campaignCache.clear();
  }
}
